import React from "react";
import Cell from "./cell";

export default class Collumn extends React.Component {
	renderCell(i) {
		return <Cell value={this.props.cells[i]} />;
	}

	render() {
		return (
			<div className="collumn" onClick={this.props.onClick}>
				{this.renderCell(0)}
				{this.renderCell(1)}
				{this.renderCell(2)}
				{this.renderCell(3)}
				{this.renderCell(4)}
				{this.renderCell(5)}
			</div>
		);
	}
}
